module.exports = __webpack_public_path__ + "static/media/virtual-courses.92d71362.jpg";